import React, { FC, useRef, useState } from 'react';

//devextreem
import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import { AppGroup, AppRow } from 'components/appComponents';
import AppFiledBox from 'components/appComponents/app-field-box';
import ModalFooter from 'components/appModalFooter';
import { DateBox } from 'devextreme-react';

import { CashFlowExcelReport } from 'bus/cash/types/cashFlowExpenseSalary';
import { useLazyRequestExcelReportQuery } from 'bus/request';

type Props = {
  visible: boolean;
  changeVisible: (visible: boolean) => void;
};

const initialForm: Omit<CashFlowExcelReport, 'cashFlowId'> = {
  dateBegin: '',
  dateEnd: '',
};

const AutoFillModal: FC<Props> = ({ changeVisible, visible }) => {
  let createGroupValidationRef = useRef<ValidationGroup>(null);

  const [form, setForm] = useState<Omit<CashFlowExcelReport, 'cashFlowId'>>(initialForm);

  const onHidden = () => {
    setForm(initialForm);
    createGroupValidationRef.current?.instance.reset();
  };

  const [cashFlowExcelReport, { isLoading }] = useLazyRequestExcelReportQuery();

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();

    if (createGroupValidationRef.current?.instance.validate().isValid) {
      await cashFlowExcelReport({ ...form });
      changeVisible(false);
    }
  };

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={() => changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Параметры"
        width={400}
        onHidden={onHidden}
        height="auto"
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit}>
              <ValidationGroup ref={createGroupValidationRef}>
                <Form id="test-facrory" formData={form}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppRow>
                      <AppGroup col={12}>
                        <AppFiledBox label="Дата начала" labelTop>
                          <DateBox
                            stylingMode="underlined"
                            type="date"
                            onValueChange={(e) => setForm((prev) => ({ ...prev, dateBegin: e as string }))}
                            useMaskBehavior
                            dateSerializationFormat="yyyy-MM-dd"
                            value={form.dateBegin}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле Дата начала" />
                            </Validator>
                          </DateBox>
                        </AppFiledBox>

                        <AppFiledBox label="Дата окончания" labelTop>
                          <DateBox
                            stylingMode="underlined"
                            type="date"
                            onValueChange={(e) => setForm((prev) => ({ ...prev, dateEnd: e as string }))}
                            useMaskBehavior
                            dateSerializationFormat="yyyy-MM-dd"
                            value={form.dateEnd}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле Дата окончания" />
                            </Validator>
                          </DateBox>
                        </AppFiledBox>
                      </AppGroup>
                    </AppRow>
                  </Item>
                </Form>
                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={handleSubmit}
                  hideModal={() => changeVisible(false)}
                  disabledSubmit={isLoading}
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default AutoFillModal;
